import {WithAPI, Changelog} from "../../api/temperature";
import {useEffect, useState} from "preact/hooks";
import {Page} from "../page";
import {Card} from "../generic/card";
import {AsRoute} from "../../app";
import styled from "styled-components";
import {Column, Columns} from "../generic/columns";

export type ChangelogProps = {
} & WithAPI & AsRoute;

const ChangelogBox = styled.dl`
    padding: 1rem .5rem;
    margin: 0;
`;

const Version = styled.dt`
    font-size: 1.2em;
    font-weight: bold;
    padding: .5rem;
    border: solid 1px ${props => props.theme.colors.secondaryBg};
    border-bottom: none;
    background: ${props => props.theme.colors.primaryBg};
    color: ${props => props.theme.colors.primaryFg};
`;

const ChangeSet = styled.dd`
    margin-bottom: 1rem;
    margin-left: 0;
    border: solid 1px ${props => props.theme.colors.secondaryBg};
    border-top: none;
    padding: .5rem;
    
    &:last-of-type {
        margin-bottom: 0;
    }
    
    > dl {
        margin: 0;
    }
`;

const Section = styled.dt`
    font-weight: bold;
`;

const Changes = styled.dd`
    margin-left: 2em;
    
    > ul {
        padding-left: 0;
        margin-top: .5rem;
        margin-bottom: 1rem;
    }
    
    &:last-of-type > ul {
        margin-bottom: 0;
    }
`;

export function Changelog(props: ChangelogProps) {
    const [changelog, setChangelog] = useState<Changelog[]>()

    useEffect(() => {
        if (changelog === undefined) {
            props.api.changelog().then((changelog) => {
                setChangelog(changelog);
            });
        }
    });

    return <Page class="container" showBackButton={true} title="Changelog">
        <Columns>
            <Column>{
                changelog !== undefined
                    ? <Card title="Changelog">
                        <ChangelogBox>{changelog.map(version =>
                            <>
                                <Version>{version.version}</Version>
                                <ChangeSet>
                                    <dl>{version.sections.map(section =>
                                        <>
                                            <Section>{section.label}</Section>
                                            <Changes>
                                                <ul>{section.entries.map(entry =>
                                                    <li>{entry}</li>
                                                )}</ul>
                                            </Changes>
                                        </>
                                    )}</dl>
                                </ChangeSet>
                            </>
                        )}</ChangelogBox>
                    </Card>
                    : null
            }</Column>
        </Columns>
    </Page>;
}
